import { ButtonModule } from 'src/app/common/button/button.module';
/**Modules */
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule } from 'ng-recaptcha';
import { InViewportModule } from 'ng-in-viewport';

import { ChatWithUsModule } from 'src/app/common/chat-with-us/chat-with-us.module';
import { ModuleLoaderModule } from 'src/app/common/module-loader/module-loader.module';

/**Components */
import { PaymentRoutingComponent } from './components/payment-routing/payment-routing.component';
import { CurrencyIconComponent } from './components/currency-icon/currency-icon.component';
import { PagenotfoundComponent } from './components/pagenotfound/pagenotfound.component';
import { LogoutComponent } from './components/logout/logout.component';
import { CommonDraftFundraiserComponent } from './components/common-draft-fundraiser/common-draft-fundraiser.component';
import { LoginViaTokenComponent } from './components/login-via-token/login-via-token.component';
import { ImgLoaderDirective } from './directives/img-loader.directive';

/**Gaurds */
import { AuthGuard } from './guards/auth/auth.guard';
import { LoginGuard } from './guards/login.guard';
import { SacGuard } from './guards/sac/sac.guard';
import { SipGuard } from './guards/sip/sip.guard';

/**Services */
import { AuthService } from '@services/auth/auth.service';
import { CampaignService } from '@services/campaign/campaign.service';
import { HomepageService } from '@services/homepage/homepage.service';
import { HttpInterService } from '@services/http-inter/http-inter.service';
import { ScriptLoaderService } from '@services/script-loader/script-loader.service';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { FundraiserService } from '@services/fundraiser/fundraiser.service';
import { SeoService } from '@services/seo/seo.service';
import { EventsService } from '@services/events/events.service';
import { FbService } from '@services/fb/fb.service';
import { ShareMessagesService } from '@services/share-messages/share-messages.service';
import { VariablesService } from '@services/variables/variables.service';
import { DonationService } from '@services/donation/donation.service';
import { PaymentService } from '@services/payment/payment.service';
import { PusherService } from '@services/pusher/pusher.service';
import { CookieService } from '@services/cookie/cookie.service';
import { VwoService } from '@services/vwo/vwo.service';
import { TickrService } from '@services/tickr/tickr.service';
import { PortfolioService } from '@services/portfolio/portfolio.service';
import { SignupService } from '@services/signup/signup.service';

const Services = [
  AuthService, CampaignService, HttpInterService, ScriptLoaderService,
  StorageService, UtilService, FundraiserService, SeoService, EventsService,
  FbService, ShareMessagesService, VariablesService, DonationService,
  PaymentService, PusherService, CookieService, HomepageService, VwoService, TickrService,
  PortfolioService, SignupService, AuthGuard, LoginGuard, SacGuard, SipGuard
];
// Pipes
import { CurrencySymbolPipe } from './pipes/currency-symbol/currency-symbol.pipe';
import { SafeHtmlPipe } from './pipes/safe-html/safe-html.pipe';
import { CustomTranslatePipe } from './pipes/translate/translate.pipe';
import { InrFormatPipe } from './pipes/inr-format/inr-format.pipe';
import { MathPipe } from './pipes/math/math.pipe';
import { UtcConvertPipe } from './pipes/utc-convert/utc-convert.pipe';
import { NumberAbbreviationPipe } from './pipes/number-abbreviation/number-abbreviation.pipe';
import { DayjsPipe } from './pipes/dayjs/dayjs.pipe';
import { DiffTimePipe } from './pipes/difftime/difftime.pipe';
import { TextEllipsisPipe } from './pipes/text-ellipsis/text-ellipsis.pipe';
import { TypeofPipe } from './pipes/typeof/typeof.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RecaptchaModule,
    InViewportModule,
    ModuleLoaderModule,
    ChatWithUsModule,
    ButtonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    MatBottomSheetModule,
    MatSelectModule
  ],
  declarations: [
    CurrencySymbolPipe,
    SafeHtmlPipe,
    CustomTranslatePipe,
    InrFormatPipe,
    MathPipe,
    UtcConvertPipe,
    DayjsPipe,
    DiffTimePipe,
    NumberAbbreviationPipe,
    PaymentRoutingComponent,
    CurrencyIconComponent,
    PagenotfoundComponent,
    LogoutComponent,
    ImgLoaderDirective,
    LoginViaTokenComponent,
    CommonDraftFundraiserComponent,
    TextEllipsisPipe,
    TypeofPipe
  ],
  exports: [
    RecaptchaModule,
    InViewportModule,
    SafeHtmlPipe,
    CustomTranslatePipe,
    InrFormatPipe,
    MathPipe,
    UtcConvertPipe,
    NumberAbbreviationPipe,
    CurrencySymbolPipe,
    DayjsPipe,
    DiffTimePipe,
    TextEllipsisPipe,
    PaymentRoutingComponent,
    CurrencyIconComponent,
    ImgLoaderDirective,
    TypeofPipe,
    MatSelectModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        // Services
        ...Services,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpInterService,
          multi: true
        }
      ]
    };
  }
}
